export const platformData = [
  {
    icon: require('modules/nps/lib/assets/capterra.svg'),
    name: 'Capterra',
    url: 'https://reviews.capterra.com/products/new/48f56907-bce9-4811-8f00-a81800652e49?utm_source=vp&utm_campaign=vendor_request',
    mainMarket: ['es', 'it', 'pt', 'de'],
  },
  {
    icon: require('modules/nps/lib/assets/g2.svg'),
    name: 'G2',
    url: 'https://www.g2.com/products/factorial/take_survey',
    mainMarket: ['us'],
  },
  {
    icon: require('modules/nps/lib/assets/trustpilot.svg'),
    name: 'Trustpilot',
    url: 'https://www.trustpilot.com/evaluate/factorialhr.com',
    mainMarket: ['fr', 'gb'],
  },
  {
    icon: require('modules/nps/lib/assets/software_advice.svg'),
    name: 'Software Advice',
    url: 'https://reviews.softwareadvice.com/products/new/48f56907-bce9-4811-8f00-a81800652e49?utm_source=vp&utm_campaign=vendor_request',
    mainMarket: [],
  },
]
